import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "tailwindcss/tailwind.css";
import useFetchData from "../../../../repo/get";
import usePutData from "../../../../repo/put";
import ReactHowler from "react-howler";
import positiveSound from "../../../../assets/positive.mp3";
import negativeSound from "../../../../assets/negative.mp3";
import Switch from "react-switch";

const CardAtribuir = () => {
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [entregadorName, setEntregadorName] = useState("");
  const [globalFilter, setGlobalFilter] = useState("");
  const [codigoRomaneio, setCodigoRomaneio] = useState("");
  const [playSound, setPlaySound] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [switchChecked, setSwitchChecked] = useState(false);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");

  const { data: motoristaData, error: motoristaError } = useFetchData(`api/motoristas/findById/${id}`);
  const { putData } = usePutData();

  const reloadData = async () => {
    try {
      if (motoristaData) {
        setEntregadorName(motoristaData.nome);
      } else {
        setError("Erro ao carregar motorista.");
      }
    } catch (err) {
      setError("Erro ao carregar dados.");
    } finally {
      setLoading(false);
    }
  };

  const { data: romaneiosData, error: romaneiosError } = useFetchData(`api/romaneios/getRetiradoAll/${id}`);
  const reloadDataTable = async () => {
    try {
      if (romaneiosData && Array.isArray(romaneiosData)) {
        const formattedData = romaneiosData.map((item) => ({
          codigo: item.codigoUid,
          
          quantidade: item.quantidade,
          entregador: item.entregador,
          data: item.data.replace("T", " ").split(".")[0],
          dataretirada: item.dataretirada.replace("T", " ").split(".")[0],
          status: item.status
        }));
        setData(formattedData);
      } else {
        setError("");
        setData([]);
      }
    } catch (err) {
      setError("Erro ao carregar dados.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    reloadData();
    reloadDataTable();
  }, [motoristaData, romaneiosData, motoristaError, romaneiosError]);

  const handleAdicionarRomaneio = async () => {
    if (!codigoRomaneio || !entregadorName) {
      setError("Por favor, preencha o código do romaneio.");
      setPlaySound(negativeSound);
      return;
    }

    setIsSubmitting(true);

    try {
      const status = switchChecked ? "alocado" : "retirado";

      const response = await putData(`api/romaneios/update/codigo/${codigoRomaneio}`, {
        motorista: parseInt(id),
        status,
        funcionario: localStorage.getItem("id"),
        base: motoristaData.base[0].id
      });

      if (response && response.message) {
        setError(response.message);
        setPlaySound(negativeSound);
      } else if (response && response.id) {
        const newRomaneio = {
          id: response.id,
          codigo: response.codigoUid,
          entregador: response.entregador.nome,
          status: response.sts,
          data: response.data.replace("T", " ").split(".")[0] || new Date().toISOString().replace("T", " ").split(".")[0],
        };
        setData((prevData) => {
          const exists = prevData.some((item) => item.codigo === newRomaneio.codigo);
          if (exists) {
            return prevData;
          }
          return [newRomaneio, ...prevData];
        });

        setPlaySound(positiveSound);
        setError("");
      } else {
        setError("Codigo romaneio inválido.");
        setPlaySound(negativeSound);
      }
    } catch (err) {
      setError("Erro ao atualizar romaneio.");
      setPlaySound(negativeSound);
    } finally {
      setIsSubmitting(false);
      setCodigoRomaneio("");
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && !isSubmitting) {
      event.preventDefault();
      handleAdicionarRomaneio();
    }
  };

  const handleSwitchChange = (checked) => {
    setSwitchChecked(checked);
  };

  if (loading) {
    return <p>Carregando...</p>;
  }

  const header = (
    <div className="flex flex-col md:flex-row  justify-between items-center">
      <input
        type="text"
        value={globalFilter}
        onChange={(e) => setGlobalFilter(e.target.value)}
        placeholder="Filtrar resultados..."
        className="p-inputtext p-component"
      />
      <h4 className="text-2xl font-bold">{data.length} Sacas  <h4 className="text-sm font-bold">{data.reduce((total, item) => total + (item.quantidade || 0), 0)} Pacotes</h4></h4>
     
    </div>
  );

  return (
    <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white p-6">

      
        <div className="flex flex-col md:flex-row  items-center justify-between">
          <div className="flex items-center justify-between mb-4">
            <h1 className="text-2xl font-bold p-component">
              {entregadorName || "Motorista não encontrado"}
            </h1>

          </div>


          <input
            type="text"
            placeholder="Adicionar romaneio ..."
            value={codigoRomaneio}
            onChange={(e) => setCodigoRomaneio(e.target.value)}
            onKeyDown={handleKeyDown}
            className="p-inputtext p-component mb-4"
          />

        
        {/* <label className="flex items-center gap-2">
          <Switch onChange={handleSwitchChange} checked={switchChecked} onColor="#86d3ff"
            onHandleColor="#2693e6"
            handleDiameter={30}
            uncheckedIcon={false}
            checkedIcon={false}
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            height={20}
            width={48}
            className="react-switch"
            id="material-switch" />
          <span className=" text-2xl font-bold">‎ ‎ ‎  {switchChecked ? "Alocar para o motorista retirar em base" : "Bipar para o motorista ir para rota"}</span>
        </label> */}
      </div>
      {error && <p className="text-red-500">{error}</p>}
      <DataTable
        value={data}
        paginator
        stripedRows
        rows={10}
        rowsPerPageOptions={[5, 10, 25, 50]}
        tableStyle={{ minWidth: "50rem" }}
        globalFilter={globalFilter}
        emptyMessage="Nenhum romaneio encontrado."
        header={header}
      >
        <Column
          field="codigo"
          header="Código do Romaneio"
          sortable
          style={{ minWidth: "12rem", fontSize: "13px" }}
          body={(rowData) => (
            <span data-label={rowData.codigo} style={{ userSelect: "text" }}>
              {rowData.codigo}
            </span>
          )}
        />

        <Column field="entregador" header="Entregador" sortable style={{ minWidth: "14rem" }} />
        <Column field="status" header="Status" sortable style={{ minWidth: "10rem" }} />
        <Column field="data" header="Data" sortable style={{ minWidth: "12rem" }} />
        <Column field="dataretirada" header="Data Retirada" sortable style={{ minWidth: "12rem" }} />
      </DataTable>

      

      {playSound && <ReactHowler src={playSound} playing={true} onEnd={() => setPlaySound(null)} />}
    </div>
  );
};

export default CardAtribuir;
